export default {
  lang: 'Deutsch',
  homeScreen: {
    title: '', // Product specific
    stayConnected: 'Verbunden bleiben',
    comingSoon: 'Demnächst verfügbar',
    messages: 'Nachrichten',
    subtitle: '',
  },
  glassWidgets: {
    errors: {
      requestFailed: 'Etwas ist schiefgelaufen. Bitte versuche es später erneut.',
    },
    programStatus: {
      title: 'Mein Status',
      loading: 'Wird geladen…',
      yourRep: 'Dein Rep',
      myProfile: 'Mein Profil',
      favorites: 'Favoriten',
      registeredOn: 'Beigetreten am:',
      graduatedOn: 'Abgeschlossen am:',
      totalBadgesEarned: 'Abzeichen insgesamt:',
      lastBookingLogged: 'Letzte erfasste Buchung:',
      currentTier: 'Aktuelles Level',
      lastBadgeEarned: 'Zuletzt erhaltenes Abzeichen:',
      currentFocus: 'Aktueller Fokus:',
      changeProfilePicture: 'Profilbild ändern',
    },
    todaysfocus: {
      title: 'Fokus heute',
      empty: 'Keine Fokusthemen für heute',
      loading: 'Wird geladen…',
      error: 'Etwas ist schiefgelaufen',
      slideNavAria: 'Foliennavigation',
      slideAria: 'Folie',
      carouselAria: 'Fokus heute',
    },
    welcome: 'Willkommen!',
    welcomeBack: 'Willkommen zurück, {firstName}!',
    notifications: {
      loading: 'Wird geladen…',
      empty: 'Keine Benachrichtigungen',
    },
    achievements: {
      title: 'Prämien & Wettbewerbe',
      loading: 'Wird geladen…',
      lastBooking: 'Letzte Einreichung',
      currentTier: 'Aktuelles Level',
      contestEntries: 'Wettbewerbsteilnahmen gesamt',
      nightsBooked: 'Gebuchte Nächte',
      totalRevenue: 'Gemeldeter Gesamtumsatz',
      noBookingData: 'Keine Buchungsdaten verfügbar.',
      notAvailable: 'k. A.',
      fileUploadSuccess: 'Datei wurde erfolgreich hochgeladen.',
      quickSubmit: {
        title: 'Schnelleinreichung',
        uploading: 'Wird hochgeladen…',
        clear: 'Löschen',
        submit: 'Einreichen',
        submitSuccessSimulated: 'Buchung erfolgreich eingereicht',
      },
    },
  },
  notification: {
    newAndNow: 'Neu & Aktuell!',
    alert: 'Warnung',
    message: 'Nachricht',
    badge: 'Neues Abzeichen',
    contest: 'Wettbewerb',
    'content-update': 'Inhalts-Update',
    events: 'Veranstaltungen',
    other: 'Benachrichtigung',
    welcome: 'Willkommen',
  },
  loginScreen: {
    version2custom: {
      defaultAmbassador: {
        step2: 'Schritt 1: Konto erstellen',
        step3: 'Schritt 2: Profil erstellen',
      },
      houstonInsider: {
        hospitalityCheckboxLabel:
          'Dieses Programm ist derzeit auf Beschäftigte im Gastgewerbe mit Wohnsitz in Houston beschränkt. Wir hoffen zwar, die Teilnahmebedingungen in Zukunft auszuweiten, weisen jedoch darauf hin, dass Teilnehmer, die die derzeitigen Voraussetzungen nicht erfüllen, möglicherweise aus dem Programm ausgeschlossen werden.',
      },
      app1857: {
        fields: {
          howDiscoveredKLA: 'Wie haben Sie die Key Lime Academy entdeckt?',
          tradeshowDetailLabel: 'Welche Messe oder Konferenz?',
          tradeshowDetailPlaceholder: 'Bitte geben Sie den Namen der Messe oder Konferenz ein',
          discoverVisitFloridaKeys: 'Website von Visit Florida Keys',
          discoverSearchEngine: 'Suchmaschine (z. B. Google, Yahoo)',
          discoverAiTool: 'KI-Tool/Suche (z. B. ChatGPT, Perplexity)',
          discoverSocialMedia: 'Soziale Medien (z. B. Instagram, X, Facebook, LinkedIn)',
          discoverEmailNewsletter: 'E-Mail oder Newsletter',
          discoverWordOfMouth: 'Mundpropaganda',
          discoverTradeshowConference:
            'Messe oder Konferenz (bitte geben Sie an, um welche Veranstaltung es sich handelt)',
          discoverOtherTravproAffiliate: 'Andere Partner-Websites von TravPRO',
        },
      },
      app1865: {
        fields: {
          topTravelType: 'Welcher Reisetyp ist der wichtigste, den Sie verkaufen?',
          travelTypeAdventure: 'Abenteuer/Soft Adventure/Expedition',
          travelTypeAllInclusive: 'All Inclusive',
          travelTypeBusinessMice: 'Business/MICE',
          travelTypeCultureExperiential: 'Kultur/Erlebnis',
          travelTypeCruise: 'Kreuzfahrt',
          travelTypeFamilyMultiGen: 'Familie/Mehrgenerationen',
          travelTypeRomance: 'Romantik/Hochzeit/Flitterwochen',
          travelTypeLuxury: 'Luxus',
          travelTypeRail: 'Bahn',
          travelTypeTours: 'Touren',
          travelTypeWellness: 'Wellness/Gesundheit/Spa',
          travelTypeLgbtq: 'LGBTQ+',
        },
      },
      app1826: {
        fields: {
          optMarketing:
            'Bleiben Sie mit dem Reisebranchen-Team und den Partnern dieses Programms in Kontakt und erhalten Sie aktuelle Informationen.',
        },
      },
      app842: {
        fields: {
          segments: 'Welche Segment(e) verkaufen Sie hauptsächlich?',
          segmentLeisure: 'Freizeit',
          segmentCorporate: 'Unternehmen',
          segmentGroup: 'Gruppe',
        },
      },
    },
    version2: {
      homeTitle: 'Schauen wir, ob wir ein bestehendes Profil für Sie in unserem System finden können.',
      homeTitleSub:
        'Geben Sie die E-Mail-Adresse ein, die Sie normalerweise für die Anmeldung bei Schulungsprogrammen verwenden.',
      noAccount:
        'Kein Konto gefunden ({email}), bitte versuchen Sie es mit einer anderen E-Mail oder erstellen Sie jetzt ein Konto.',
      continueButton: 'Weiter',
      success: 'Ihr Konto wurde erfolgreich aktualisiert! Sie werden in Kürze zur Startseite weitergeleitet.',
      successNewAccount:
        'Um Ihre Registrierung abzuschließen, erhalten Sie eine Bestätigungs-E-Mail zur Verifizierung Ihres Kontos.',
      loginButton: 'Anmelden',
      matchFound: 'Wir haben eine Übereinstimmung gefunden, bitte geben Sie Ihr Passwort ein, um fortzufahren.',
      magicLink: 'Anmeldung über einen Link in Ihrer E-Mail:',
      magicLinkButton: 'Magic Link anfordern',
      magicLinkTitle: 'Lassen Sie sich einen direkten Link an Ihre E-Mail senden, der Sie sofort anmeldet.',
      otherEmailButton: 'Senden',
      title:
        'Bitte nehmen Sie sich einen Moment Zeit, um alle Informationen unten auszufüllen, da diese Ihr persönliches Profil und Ihre Kontaktinformationen ausfüllen werden.',
      titleIndustry:
        'Bitte nehmen Sie sich einen Moment Zeit, um alle Informationen unten auszufüllen, da diese Ihr persönliches Profil und Ihre Kontaktinformationen ausfüllen werden.',
      register: 'Konto erstellen',
      agent: 'Reiseberater',
      visitor: 'Branchenbesucher',
      ambassador: 'Botschafter',
      step1: 'Schritt 1: Benutzertyp',
      step2: 'Schritt 2: Konto erstellen',
      step3: 'Schritt 3: Profil erstellen',
      marketingOptIn:
        'Sind Sie sicher, dass Sie nicht daran interessiert sind, mit dem Reise-Trade-Team dieses Programms in Verbindung zu bleiben?',
      optIn: 'Ja, ich bin interessiert',
      optOut: 'Nicht interessiert',
      step2Sub1: 'Erzählen Sie uns von sich',
      step2Sub2: 'Erzählen Sie uns von Ihrem Unternehmen',
      step2Sub3: 'Erzählen Sie uns etwas über Ihren Arbeitgeber',
      privacyHead: 'KOMMUNIKATIONSPRÄFERENZEN',
      privacySub:
        'Markieren Sie die Kästchen unten, um sicherzustellen, dass Sie wichtige Mitteilungen vom Reise-Trade-Team des Anbieters (Produktupdates und Ankündigungen, Belohnungen, Anreize, FAMs usw.) und Reise-Trade-Netzwerk- und Verkaufsunterstützungsinitiativen von TravPRO Mobile erhalten.',
      privacy: 'Wir schützen Ihre Privatsphäre und verkaufen, missbrauchen oder verraten niemals Ihr Vertrauen.',
      store: 'Laden Sie dieses Programm einfach in Ihrem App Store herunter:',
      powered: 'UNTERSTÜTZT VON',
      toastMessage: {
        forgotSuccess:
          'Wir haben Ihnen den Link zum Zurücksetzen des Passworts per E-Mail gesendet! Sie werden in 10 Sekunden zur Anmeldeseite weitergeleitet.',
        emailNotExisting: 'Die eingegebene E-Mail-Adresse existiert nicht.',
        magicLinkMessage: 'Bitte warten Sie, wir melden Sie gerade an.',
        magicLinkError:
          'Wir konnten Ihr Konto nicht in unserer Datenbank finden, bitte melden Sie sich manuell an. Sie werden in 10 Sekunden weitergeleitet.',
        magicLinkError1:
          'Wir konnten kein gültiges Token finden, bitte melden Sie sich an oder fordern Sie einen neuen Magic Link an. Falls dieses Problem weiterhin besteht, kontaktieren Sie uns unter: info@travpromobile.com.',
        magicLinkError2:
          'Wir konnten Ihr Konto nicht in unserer Datenbank finden, bitte melden Sie sich manuell an. Sie werden in 10 Sekunden weitergeleitet.',
        magicLinkSuccess: 'Überprüfen Sie Ihre E-Mail unter {email}. Sie enthält einen Magic Link, der Sie anmeldet.',
        magicLinkErrorWait: 'Bitte warten Sie 5 Minuten zwischen Magic Link-Anfragen.',
        emailNotFoundError:
          'Die eingegebene E-Mail-Adresse kann in unseren Aufzeichnungen nicht gefunden werden. Bitte überprüfen Sie auf Rechtschreibfehler oder erstellen Sie ein Konto.',
      },
      errors: {
        zipCodeNotFound: 'Postleitzahl nicht gefunden, versuchen Sie es erneut',
        zipCodeOnlyNumbers: 'Postleitzahl darf nur Zahlen enthalten',
        password: 'Bitte geben Sie ein Passwort ein',
        passwordNotMatching: 'Die eingegebenen Passwörter stimmen nicht überein',
        passwordTooShort: 'Passwort muss mindestens 8 Zeichen lang sein',
        emailExists:
          'Diese E-Mail-Adresse existiert bereits oder ist ungültig. Bitte versuchen Sie es mit einer anderen E-Mail-Adresse oder melden Sie sich bei Ihrem Konto an.',
        fillInAllFields: 'Bitte füllen Sie alle erforderlichen Felder aus',
        fillInEmail: 'Bitte geben Sie Ihre E-Mail ein.',
        emailNotExisting: 'Die eingegebene E-Mail-Adresse existiert nicht.',
      },
      fields: {
        forgotSubCopy: 'Passwort vergessen & möchten es ändern? ',
        forgotSubCopy2:
          'Möchten Sie das Passwort ganz umgehen? Wir senden Ihnen eine E-Mail mit einem Magic Link, der Sie automatisch in das Programm einloggt. ',
        city: 'Stadt',
        companyName: 'Firmenname',
        role: 'Ihre Rolle',
        description: 'Was beschreibt das Geschäft Ihres Unternehmens am besten?',
        country: 'Land',
        password: 'Passwort',
        passwordRegister: 'Passwort wählen (mindestens 8 Zeichen)',
        passwordConfirm: 'Passwort bestätigen',
        firstName: 'Vorname',
        lastName: 'Nachname (Familie)',
        agency: 'Ihr Agenturname',
        employer: 'Name des Arbeitgebers',
        employerRole: 'Was beschreibt Ihre Rolle am besten?',
        employerYears: 'Seit wie vielen Jahren leben Sie in der Region, in der Sie arbeiten?',
        title: 'Ihre Rolle (Eine auswählen)',
        company: 'Firmenname',
        select: 'Wählen Sie eine Option unten',
        state: 'Bundesland',
        province: 'Provinz/Region/Bundesland',
        zipCode: 'Postleitzahl',
        postalCode: 'Postleitzahl',
        affiliate: 'Was ist Ihre HAUPT-Agentur-Zugehörigkeit?',
        hostAgency: 'Ihre Host-Agentur?',
        ataCliaArc: 'Wie lautet Ihre ATA/CLIA/ARC-Nummer?',
        executive: 'Geschäftsführung',
        management: 'Management',
        marketing: 'Marketing',
        sales: 'Vertrieb',
        coordinator: 'Koordinator',
        other: 'Andere',
        opt: 'Bleiben Sie mit dem Reise-Trade-Team dieses Programms verbunden und erhalten Sie Updates.',
        optMarketing: 'Bleiben Sie mit TravPRO bezüglich ähnlicher Programme und Veranstaltungen verbunden.',
        retail: 'Einzelhandelsgeschäft',
        home: 'Heimbasierter Agent',
        independent: 'Unabhängiger Auftragnehmer',
        host: 'Host-Agentur',
        call: 'Call Center oder webbasierte Agentur',
        describes: 'Was beschreibt Sie und das Geschäft Ihrer Agentur am besten? ',
        invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
        roleDMO: 'DMO',
        roleEventEmployee: 'Veranstaltungsmitarbeiter',
        roleHotelEmployee: 'Hotelmitarbeiter',
        roleRestaurantBar: 'Restaurant-/Barmitarbeiter',
        roleRetailService: 'Mitarbeiter im Einzelhandel und Dienstleistungsbereich',
        roleTourActivity: 'Mitarbeiter bei Tour- und Aktivitätsveranstaltern',
        roleTransportation: 'Mitarbeiter im Transportwesen',
        roleOther: 'Sonstiges',
        yearsJustArrived: 'Erst seit kurzem hier (<6 Monate)',
        years1to5: '1 bis 5 Jahre',
        years5to10: '5 bis 10 Jahre',
        years10Plus: '10+ Jahre',
      },
    },
    title: 'Schulungs- und Verkaufsunterstützungsprogramm für Reiseprofis', // Product specific (TravPRO text or ChannelPRO text)
    welcome: {
      headerTop: 'Willkommen bei',
    },
    sellingPoints: {
      // All selling points can be product specific
      0: 'Lernen, Bewerben & Verkaufen unterwegs',
      1: 'Multimedia-Schulung auf allen Geräten',
      2: 'Abschlusszertifikat',
      3: 'Fertige Verkaufspräsentationen',
      4: 'Wirkungsvolle Werbematerialien',
      5: 'Insider-Tipps & Aktionen',
      6: 'Echtzeit-Produktverzeichnis',
      7: 'Aktuelle Nachrichten & Updates',
    },
    emailPrompt:
      'Bitte geben Sie Ihre E-Mail-Adresse und Ihr Passwort ein, um zu bestätigen, dass Sie ein Reiseprofi sind.', // Product specific (TravPRO or ChannelPRO text)
    tAndC: {
      agree: 'Durch Fortfahren stimmen Sie unserer ',
      privacyPolicy: 'Datenschutzrichtlinie',
      and: ' und unseren ',
      termsConditions: 'Allgemeinen Geschäftsbedingungen',
    },
    fields: {
      what: 'Welche Art von Reisen verkaufen Sie?',
      what1: 'Was ist die #1 Art von Reisen, die Sie verkaufen?',
      what2: 'Was ist die #2 Art von Reisen, die Sie verkaufen?',
      what3: 'Was ist die #3 Art von Reisen, die Sie verkaufen?',
      agency: 'Agentur *',
      email: 'E-Mail',
      password: 'Passwort',
      passwordConfirm: 'Passwort bestätigen *',
      firstName: 'Vorname *',
      lastName: 'Nachname *',
      agencyName: 'Agenturname *',
      city: 'Stadt *',
      stateProvince: 'Bundesland / Provinz *',
      salutation: 'Anrede *',
      required: 'Erforderlich',
      invalidEmail: 'Ungültige E-Mail-Adresse',
      complete: 'Schritt 2: Vervollständigen Sie Ihr Profil',
      tell: 'Erzählen Sie uns von sich',
      title: 'Geschäftstitel *',
      host: 'Host-Agenturname',
      country: 'Land / Region',
      select: 'Bitte wählen Sie eine Option unten',
      header2: 'Welche Segmente verkaufen Sie hauptsächlich?',
      step2: 'Beschreiben Sie Ihr Unternehmen',
      leisure: 'Freizeit',
      corporate: 'Geschäftlich',
      group: 'Gruppe',
      affiliate: 'Was ist Ihre Hauptzugehörigkeit?',
      forgot:
        'Passwort vergessen? Klicken Sie auf die Schaltfläche unten und wir senden Ihnen eine E-Mail zum Zurücksetzen Ihres Passworts.',
    },
    noAgent: {
      noAgentButton: 'Ich bin kein Berater',
      title: 'Vielen Dank für Ihr Interesse an\n{clientName}', // Product specific
      messageWeb:
        'Der Inhalt dieser Website ist ausschließlich für Reiseprofis.\nUm mehr über {clientName} zu erfahren, besuchen Sie bitte: ', // Product specific
      messageMobile:
        "Einige Inhalte in dieser App sind ausschließlich für Reiseprofis, aber schauen Sie sich gerne eine Vorschau dessen an, was diese App zu bieten hat, indem Sie auf 'Weiter' drücken.", // Product specific
      continue: 'Weiter',
      visitWebsite: 'Website besuchen',
    },
    newUser: 'Neuer Benutzer',
    register: 'Registrieren',
    registered: 'Diese E-Mail ist bereits registriert',
    forgot: 'Passwort zurücksetzen',
    header:
      'Bitte nehmen Sie sich einen Moment Zeit, um alle Informationen unten auszufüllen, da dies Ihr Profil und Ihre Kontaktinformationen ausfüllt.',
    step1: 'Schritt 1: Vervollständigen Sie Ihre E-Mail-Adresse und wählen Sie ein Passwort.',
  },
  welcomeScreen: {
    helloUser: 'Hallo {{name}}',
    hello: 'Hallo,',
    fromAgency: 'von {{agency}}',
    notUser: 'Nicht {{name}}?',
    introOnline:
      'Trainieren Sie sofort online oder laden Sie den Inhalt vor, damit er immer für die Offline-Nutzung verfügbar ist!',
    introOffline:
      'Sie haben bereits die neueste Version vorgeladen. Beginnen Sie jederzeit und überall mit dem Training oder Verkaufen!',
    startTraining: 'Lernen beginnen',
    continueTraining: 'Lernen fortsetzen',
    graduated: 'Herzlichen Glückwunsch!',
    downloader: {
      preload: 'Vorladen',
      stop: 'stoppen',
      init: 'Wird initialisiert...',
      lastUpdate: 'Letztes Update: ',
    },
  },
  trainingScreens: {
    start: 'Start',
    continue: 'Weiter',
    review: 'Überprüfen',
    restart: 'Neustart',
    durationInMinutes: '{number} Minuten',
    percentageComplete: '{number}% Abgeschlossen',
    unlock: 'Entsperre dieses Kapitel, indem du Trainingskapitel {number} abschließt.',
    unlockFoundation: 'Entsperre dieses Kapitel, indem du Trainingskapitel {number} abschließt.',
    unlockSpecialization: 'Freischalten durch das Erwerben Ihres Zertifikats.',
    unlockPartners: 'Freischalten durch das Erwerben Ihres Zertifikats.',
    unlockRetain: 'Entsperre dieses Kapitel, indem du die Grundlagen in {name} abschließt.',
    unlockSubtitle: 'Entsperre weitere Kapitel, indem du Trainingskapitel abschließt.',
    allUnlocked: 'Sie haben alle Kapitel freigeschaltet!',
    certificate: 'Zertifikat',
    courseComplete: 'Weiter',
    endReached: 'Sie haben das Ende erreicht',
    retainEnd:
      'Verwenden Sie die obere Leiste, um in diesem Kapitel zu navigieren, oder drücken Sie die Zurück-Taste, um zur Übersicht zurückzukehren.',
    watchListenRead: 'Schauen, Hören & Mehr lesen',
    trouble:
      'Es scheint, als hätten Sie Schwierigkeiten, bitte lesen Sie den Inhalt der vorherigen Seite(n) erneut und versuchen Sie es noch einmal.',
    confirm: 'Bestätigen Sie Ihre Antwort',
    choose: 'Bitte wählen Sie eine Antwort',
    skip: 'Zurück >',
    viewAllTitle: 'Trainingstipp',
    viewAll:
      'Um zur nächsten Seite zu gelangen, lesen Sie bitte alle Inhalte auf dieser Seite sorgfältig durch. Dazu gehört, dass Sie sich alle Videos ansehen, auf die Symbole klicken, um ergänzende Materialien anzuzeigen, und die Fragen auf den Seiten richtig beantworten. Diese hilfreichen Informationen wurden bereitgestellt, um Ihr Training zu verbessern und sicherzustellen, dass Sie den PRO-Status erreichen.',
    fillBlanks: 'Füllen Sie die Lücke(n) aus:',
    next: 'Nächste Frage',
    retry: 'Erneut versuchen',
    fastTrackContinue: 'Fast Track fortsetzen',
    fastTrackMoveToFull: 'Fast Track abbrechen',
    fastTrackPrompt:
      'Halten Sie sich bereits für einen BVI-Experten? Möchten Sie versuchen, Ihre Zertifizierung im Fast Track zu absolvieren? Ein Versuch, 15 Fragen, erforderliche Bestehensgrenze: 80 % (B).',
    grading: 'Ihre Endnote ist: {grade}',
  },
  nav: {
    home: 'Startseite',
    train: 'Trainieren',
    learn: 'Lernen',
    retain: 'Behalten',
    directory: 'Verzeichnis',
    showRoom: 'Vitrinen',
    showcases: 'Vitrinen',
    destinationShowcases: 'Reiseziel\nVitrinen',
    offers: 'Angebote',
    promote: 'Bewerben',
    sell: 'Verkaufen',
    info: 'Info',
    rewards: 'Belohnungen',
    achievements: 'Leistungen',
    media: 'Medien',
    favorites: 'Favoriten',
    contact: 'Team kennenlernen',
    reportCard: 'Diplom anzeigen',
    accountSettings: 'Kontoeinstellungen',
    changeProfileImage: 'Profilbild ändern',
    messages: 'Nachrichten',
    search: 'Suchen',
    manageImpersonation: 'Benutzer imitieren',
  },
  impersonateView: {
    title: 'Benutzer imitieren',
    description:
      'Geben Sie die E-Mail-Adresse des Benutzers ein, den Sie imitieren möchten. Sie müssen bereits authentifiziert sein, damit die Imitation funktioniert.',
    returnToApp: 'Zurück zur App',
    emailLabel: 'E-Mail-Adresse',
    startImpersonation: 'Imitation starten',
    impersonating: 'Imitiere…',
    confirmImpersonation: 'Imitation bestätigen',
    confirming: 'Bestätige…',
    endImpersonation: 'Imitation beenden',
    ending: 'Beende…',
    currentlyImpersonating: 'Sie imitieren derzeit {email}. Sie können die Imitation unten beenden.',
    missingEmail: 'Bitte geben Sie eine E-Mail-Adresse ein, die imitiert werden soll.',
    tokenFetched: 'Imitationstoken für {email} abgerufen. Profil wird vor der Bestätigung überprüft.',
    previewFailed: 'Benutzerprofil für die Imitation konnte nicht abgerufen werden.',
    startFailed: 'Imitation konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
    confirmFailed: 'Imitation konnte nicht bestätigt werden. Bitte versuchen Sie es erneut.',
    endFailed: 'Imitation konnte nicht beendet werden. Bitte versuchen Sie es erneut.',
    previewLabel: 'Imitationsantwort',
  },
  contentHeaders: {
    train: 'Trainieren',
    retain: 'Behalten',
    subapps: ' Partner MicroLearning Module',
    subAppsFull: ' PARTNER VERKAUFSBEGLEITER',
    maintrainings: 'Die Grundlage',
    subtrainings: 'Die Erfahrung',
    fastTrack: 'Fast Track',
  },
  pageDescriptions: {
    train: 'Bilden Sie sich weiter, engagieren Sie sich und werden Sie zum Experten.',
    trainAmbassador: 'Bilden Sie sich weiter, engagieren Sie sich und werden Sie zum erfahrenen Markenbotschafter.',
    showroom: '',
    retain:
      'Herzlichen Glückwunsch zum Abschluss Ihrer Schulung! Sie haben nun Ihre Anlaufstelle freigeschaltet, um Ihr Expertenwissen zu behalten und Ihre Verkaufsbemühungen zu unterstützen. Nutzen Sie diesen Bereich, um Produktfragen fachmännisch zu beantworten oder sogar als spontane Verkaufspräsentation — jederzeit, überall und von jedem Gerät.',
    retainAmbassador:
      'Herzlichen Glückwunsch zum Abschluss Ihrer Schulung! Sie haben nun Ihre Anlaufstelle freigeschaltet, um Ihr Expertenwissen zu behalten und Ihre Verkaufsbemühungen zu unterstützen. Nutzen Sie diesen Bereich, um Produktfragen fachmännisch zu beantworten oder sogar als spontane Verkaufspräsentation — jederzeit, überall und von jedem Gerät.',
    promote:
      'Teilen Sie diese Artikel, um Interesse zu wecken und ein Gespräch mit Kunden und Interessenten zu beginnen.',
    promoteAmbassador:
      'Hier finden Sie Ressourcen, die Sie über Tourismus-Grundlagen auf dem Laufenden halten, sowie interessante Inhalte, die Sie mit Besuchern teilen können und ihnen helfen, das Beste am Reiseziel zu erleben.',
    sell: 'Beantworten Sie Kundenfragen und schließen Sie den Verkauf wie ein Profi mit umfassenden Ressourcen und gezielter Verkaufsunterstützung ab.',
    favorites: 'Schauen Sie sich Ihre persönlich favorisierten Inhalte an',
    search: 'Durchsuchen Sie alle Inhalte',
    subapps: 'Verdienen Sie ein Spezialist-Abzeichen, indem Sie diese schnellen Einkapitel-Partner-Module abschließen.',
    subAppsFull: 'Erreichen Sie vollen Expertenstatus, indem Sie unsere Partner kennenlernen',
    maintrainings: 'Schließen Sie diese wesentlichen Module ab, um Ihr Zertifikat zu verdienen.',
    subtrainings: 'Verbessern Sie Ihr Spiel und verdienen Sie ein Abzeichen für jedes Spezialisierungskapitel unten.',
    fastTrack: 'Sie befinden sich derzeit im Fast Track. Schließen Sie ihn ab, um Ihre Note zu erhalten!',
  },
  general: {
    chapter: 'Kapitel',
    next: 'Weiter',
    yes: 'Ja',
    no: 'Nein',
    previous: 'Vorherige',
    submit: 'Senden',
    back: 'Zurück',
    close: 'Schließen',
    page: 'Seite',
    search: 'Suchen',
    selectLanguage: 'Sprache auswählen',
    logIn: 'Anmelden',
    logOut: 'Abmelden',
    viewItem: '{type} anzeigen',
    imageNotFound: 'Bild nicht gefunden',
    noResultsFor: 'Keine Ergebnisse gefunden für {query}',
    noFavorites: 'Sie haben noch keine Favoriten.',
    noMessages: 'Sie haben noch keine Nachrichten erhalten!',
    resultsFor: 'Ergebnisse für: {{query}}',
    showAll: 'Alle anzeigen',
    connectionError: 'Verbindungsfehler',
    alreadyExists: 'Existiert bereits',
    pageNotFound: '404 Seite nicht gefunden!',
    oops: 'Ups...',
    overview: 'Zur Übersicht zurückkehren',
    complete: 'Weiter',
    courseComplete: 'Kapitel abgeschlossen!',
    chapterComplete: 'Kapitel abgeschlossen!',
    message: '{count} Nachricht',
    messagePlural: '{count} Nachrichten',
    viewBadge: 'Anzeigen',
    downloadBadge: 'Abzeichen herunterladen',
    viewBadge2: 'Abzeichen',
  },
  itemTypes: {
    image: 'Bild',
    brochure: 'Sammlung',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Sammlung',
  },
  questions: {
    dials: 'Drehen Sie die Regler, um zur Antwort zu passen',
    fitb: 'Füllen Sie die Lücke(n) aus',
    flip: 'Ändern Sie die Zahl, um zur Antwort zu passen',
    multipleChoice: 'Wählen Sie die richtige(n) Antwort(en)',
    slider: 'Wählen Sie die richtige Antwort mit dem Schieberegler',
    map: 'Beantworten Sie die Frage, indem Sie die richtige Stelle auf der Karte antippen',
    dropdown: 'Wählen...',
    true: 'Wahr',
    false: 'Falsch',
    arrangeTheWords:
      'Klicken Sie die Wörter in der richtigen Reihenfolge an, um den Satz zu vervollständigen, und klicken Sie dann auf Absenden:',
    matchTheSentence:
      'Klicken Sie links auf eine Phrase und dann rechts auf die passende. Ordnen Sie alle Paare zu, um die Frage zu beantworten.',
  },
  reportCard: {
    download: 'Herunterladen',
    email: 'E-Mail',
    print: 'Drucken',
  },
  cookies: {
    consent: 'ZUSTIMMEN',
    optout: 'Ablehnen',
    settings: 'Datenschutzeinstellungen',
    message:
      'Sie haben uns noch nichts über Ihre Datenschutzpräferenzen mitgeteilt! Das ist in Ordnung, aber wir möchten Ihnen die beste Erfahrung mit dem Sales Companion bieten.',
    disabled: 'Es sieht so aus, als hätten Sie die Verwendung von Cookies deaktiviert.',
    use: 'Die {{appName}} erfordert die Verwendung von Cookies, um Ihnen die beste Erfahrung zu bieten.',
    details: 'Wofür werden die Cookies verwendet?',
    enable: 'Hier erfahren Sie, wie Sie Ihre Cookies aktivieren {{here}}.',
    here: 'hier',
  },
  notLoggedIn: {
    super: 'Sie sind nicht angemeldet',
    title: 'Sie müssen angemeldet sein, um diesen Inhalt anzuzeigen',
    guest: 'Gast',
  },
  demo: {
    message:
      'Diese Website ist eine Demo des finalen Produkts. Es befindet sich derzeit in der Entwicklung und ist kein vollständiges Produkt.',
    consent: 'Verstanden!',
  },
  share: {
    header: 'Teilen Sie diese Ressource in Ihren bevorzugten sozialen Medien!',
    download: 'Herunterladen',
    button: 'Teilen',
  },
  sharing: {
    copyURL: 'Link kopieren',
    copied: 'Kopiert',
  },
  breadCrumbs: {
    page: 'Seite',
  },
  onMobile: {
    header: 'Es sieht so aus, als würden Sie versuchen, auf die {appName}-App von einem mobilen Gerät aus zuzugreifen',
    body: 'Um dieses Programm herunterzuladen, besuchen Sie einfach Ihren App Store und suchen Sie nach {appName} oder klicken Sie auf eine der Schaltflächen unten',
    benefits: {
      header: 'Dies bietet Ihnen:',
      1: 'Lernen, Bewerben & Verkaufen unterwegs',
      2: 'Multimedia-Training auf verschiedenen Geräten',
      3: 'Abschlusszertifikat',
      4: 'Fertige Verkaufspräsentationen',
      5: 'Wirkungsvolle Werbematerialien',
      6: 'Echtzeit-Produktverzeichnis',
      7: 'Aktuelle Nachrichten & Updates',
    },
  },
  directoryView: {
    search: 'Suchen...',
    amountOfResults: 'Anzahl der Ergebnisse: ',
    filter: 'Filter',
    filters: 'Filter:',
    subFilter: 'Unterfilter',
    category: 'Kategorie',
    subcategory: 'Unterkategorie',
    resetFilters: 'Filter zurücksetzen',
    showResults: 'Ergebnisse anzeigen',
    clear: 'Löschen',
    noResults: 'Keine Ergebnisse gefunden. Bitte versuchen Sie es mit einer anderen Suche.',
    resetMap: 'Karte zum Start zurücksetzen >',
    viewNow: 'Jetzt anzeigen >',
    viewWebsite: 'Website besuchen',
    viewOnMap: 'Auf der Karte anzeigen',
    amenities: {
      gym: 'Fitnessstudio/Fitnesscenter',
      spa: 'Spa',
      meeting_room: 'Besprechungs-/Konferenzräume',
      pools: 'Schwimmbad',
      accessible_property: 'Barrierefreie Zimmer',
      bars: 'Bar/Lounge',
      golf: 'Golf/Minigolf',
      beachfront: 'Privater Strandzugang',
      restaurants: 'Restaurant',
      waterfront: 'Am Wasser',
      villa_product: 'Villa',
      non_smoking_resort: 'Nichtraucher-Resort',
      four_star: '4 Sterne',
      five_star: '5 Sterne',
      four_star_diamond: '4-Sterne-Diamond',
      five_star_diamond: '5-Sterne-Diamond',
      kitchenette_extended_stay: 'Kitchenette/Langzeitaufenthalt',
      all_suite: 'Nur Suiten',
      family_friendly: 'Familienfreundlich',
      casino: 'Kasino',
      downtown: 'Innenstadt',
      on_strip: 'Am Strip',
      private_airstrip: 'Privater Landeplatz',
      fishing_lodge: 'Angelhütte',
      dive_center: 'Tauchzentrum',
      selfCatering: 'Selbstversorgung',
      marina: 'Yachthafen',
    },
  },
  directoryProfileView: {
    website: 'Website:',
    phone: 'Telefon:',
    altPhone: 'Alternative Telefonnummer:',
    tollFree: 'Gebührenfrei:',
    fax: 'Fax:',
    address: 'Adresse:',
    about: 'Über:',
    starRating: 'Sterne-Bewertung:',
    cuisine: 'Küche:',
    email: 'E-mail:',
    contactPerson: 'Ansprechpartner:',
    experiences: 'ERLEBNISSE',
    accommodationType: 'Unterkunftsart:',
    amenitiesNumberOfRooms: 'Anzahl der Zimmer: ',
    amenitiesTitle: 'Ausstattung:',
    socialsTitle: 'SOZIALE MEDIEN:',
    socialTripadvisor: 'TripAdvisor',
    socialYelp: 'Yelp',
    socialYoutube: 'YouTube',
    socialInstagram: 'Instagram',
    socialFacebook: 'Facebook',
    socialTwitter: 'X',
    socialPinterest: 'Pinterest',
    socialMedia: 'Soziale Medien',
    numberOfRoomsTitle: 'Anzahl der Zimmer:',
    roomsCount: 'Zimmer: {count}',
    listingNotFound: 'Eintrag nicht gefunden',
  },
  directory: {
    artsentertainment: 'Kunst & Unterhaltung',
    conventionservices: 'Kongressdienstleistungen',
    divingsnorkeling: 'Tauchen & Schnorcheln',
    film: 'Film',
    hotels: 'Hotels',
    lgbtgymsandspas: 'LGBT+: Fitnessstudios und Spas',
    lgbtshopping: 'LGBT+: Shopping',
    lgbtwheretostay: 'LGBT+: Wo übernachten',
    multiculturaldining: 'Multikulturelles Essen',
    multiculturalnightlife: 'Multikulturelles Nachtleben',
    nightlife: 'Nachtleben',
    petfriendly: 'Haustierfreundlich',
    restaurants: 'Restaurants',
    shopping: 'Shopping',
    spas: 'Spas',
    sports: 'Sport',
    transportation: 'Transport',
    venues: 'Veranstaltungsorte',
    waterways: 'Wasserwege',
    waystoplay: 'Spielmöglichkeiten',
    weddinglocations: 'Hochzeitsorte',
    weddingvendors: 'Hochzeitsdienstleister',
    attraction: 'Attraktionen',
    cvb: 'Tourismusverbände',
    accommodation: 'Unterkünfte',
  },
  preregisterview: {},
  custom: {
    splitUsers: 'Ich bin ein ...',
    brandAmbassador: 'Markenbotschafter',
    travelPro: 'Reiseprofi',
  },
  rewards: {
    rewards: 'Belohnungen',
    title: 'Willkommen im Belohnungszentrum',
    subheader: 'Buchungseinreichungen und Belohnungen verfolgen und teilen',
    titleAmbassador: 'Willkommen im Leistungszentrum',
    subheaderAmbassador: 'Verfolge deine Trainingsleistungen, löse deine Prämien ein und teile deine Zertifizierungen.',
    lockedPopupNotGraduated:
      'Nutzen Sie diese exklusiven Vorteile für Absolventen, indem Sie die Schulung absolvieren und Ihr Zertifikat erwerben',
    button: 'Ihre Buchung einreichen',
    products: 'Marktplatz',
    viewAllBookings: 'Buchungen',
    viewLeaderboard: 'Bestenliste',
    viewDashboard: 'Punkte-Dashboard',
    viewRewards: 'Übersicht',
    home: {
      entries: 'Aktuelle Einträge',
      trainingAchievements: 'TRAININGSERFOLGE',
      trainingAchievementsText:
        'Verfolgen Sie Ihren Trainingsfortschritt, Zertifizierungen und den Status Ihrer Metallauszeichnungen auf dieser Seite. Sie können auch Ihr Diplom sowie alle erworbenen Abzeichen herunterladen und teilen.',
      trainingAchievementsTextNoMetallic:
        'Verfolgen Sie Ihren Trainingsfortschritt und den Status Ihrer Zertifizierungen auf dieser Seite. Sie können auch Ihr Diplom sowie alle erworbenen Abzeichen herunterladen und teilen.',
      bookingContests: 'BUCHUNGS-DASHBOARD',
      bookingContestsText: 'Verfolgen und verwalten Sie aktuelle Buchungseinreichungen einfach im Buchungs-Dashboard.',
      submitBooking: 'BUCHUNGEN EINREICHEN',
      submitBookingText: 'Hier reichen Sie Buchungen zur Aufnahme in Buchungswettbewerbe ein.',
      currentContest: 'AKTUELLER WETTBEWERB',
      currentContests: 'AKTUELLE WETTBEWERBE',
      contestEnterBookings: 'Ihre Buchungen eingeben',
      contestNow: ' jetzt!',
      contestSeeOther: 'Siehe andere ',
      contestTerms: 'Allgemeine Geschäftsbedingungen',
      noContest: 'Der Wettbewerb ist derzeit nicht verfügbar.',
    },
    bookingRewardsView: {
      title: 'Marktplatz',
    },
    bookingsView: {
      title: 'Buchungen',
    },
    leaderboardScreen: {
      title: 'PUNKTE \n Bestenliste',
      earnedpts: 'MEINE ERREICHTEN PUNKTE:',
      pointsWall: 'PUNKTE TOP 5 TRACKER:',
      startEarning: 'Beginnen Sie jetzt XP zu sammeln und treten Sie der Bestenliste bei!',
      prizes: 'Preise',
      tAndC: 'Es gelten Allgemeine Geschäftsbedingungen*',
      pointsOverview: {
        title: 'Wie man Punkte sammelt',
        booths: 'Ausstellerausstellungen besuchen',
        breakoutSessions: 'An Breakout-Sessions & Destination Spotlights teilnehmen',
        trainingSessions: 'Ein Trainingskapitel abschließen',
        adventureSpotlights: 'Familienreisetipps',
        share: 'Inhalte teilen',
        shareMax: '(bis zu {maxSharePoints} Punkte)',
        shareInfo:
          'Das Teilen wird gezählt, indem Stand-Inhalte auf X und Facebook geteilt oder der gesamte Stand mit Kollegen oder Kunden geteilt wird.',
        viewVideo: 'Video ansehen',
      },
    },
    dashboardView: {
      title: 'Buchungs-Dashboard',
      subtitle: 'Verfolgen und verwalten Sie hier Ihre Buchungseinträge.',
      badge: 'Abzeichen',
      activity: 'Buchungs-Dashboard',
      manage: 'Buchungen verwalten',
      manageSub:
        'Sortieren Sie mit den Schaltflächen oben und klicken Sie auf einen beliebigen Datensatz, um die Einreichungsdetails zu verwalten. Alle ausstehenden Einträge werden innerhalb von 72 Stunden überprüft. ',
      noBookings: 'Es gibt keine Datensätze zum Anzeigen.',
      state: {
        approvedEntries: 'Genehmigte Einträge',
        pendingEntries: 'Ausstehende Einträge',
        declinedEntries: 'Abgelehnte Einträge',
        viewAll: 'Alle anzeigen',
      },
      columns: {
        wholesaler: 'Großhändler',
        clientLastName: 'Kunden-Nachname',
        totalCostUsd: 'Gesamtkosten USD',
        hotelName: 'Hotelname',
        hotelConfirmNumber: 'Hotel-Bestätigungsnummer',
        flightNumber: 'Flugnummer',
        typeOfBooking: 'Art der Buchung',
        checkIn: 'Check-In',
        checkOut: 'Check-Out',
        status: 'Status',
      },
    },
    bookingForm: {
      title: 'Buchungseinreichungsformular',
      subTitle: 'Geben Sie Ihre Buchung ein:',
      required: '* Kennzeichnet ein Pflichtfeld',
      email: 'Agenten-E-Mail',
      agentFirstName: 'Vorname des Agenten',
      agentLastName: 'Nachname des Agenten',
      company: 'Firmenname',
      iata: 'IATA/CLIA #',
      stateProvince: 'Bundesland/Provinz',
      postalCode: 'Postleitzahl *',
      country: 'Land',
      clientLastName: 'Nachname des Kunden',
      confirmationNumber: 'Hotelbestätigungsnummer',
      flightNumber: 'Flugnummer',
      hotelName: 'Hotelname',
      bookingNumber: 'Buchungsbestätigungsnummer',
      numberOfGuests: 'Anzahl erwachsener Gäste',
      bookingDate: 'Buchungsdatum',
      tourOperator: 'Reiseveranstalter / Buchungsmethode',
      firstName: 'Vorname',
      lastName: 'Nachname des Gastes',
      guestLastName: 'Nachname des Gastes',
      accommodation: 'Gebuchtes Resort/Hotel/Unterkunft',
      select: 'Eine Option auswählen',
      wholesaler: 'Großhändlername (falls zutreffend): bei direkter Buchung geben Sie KEINE ein',
      arrivalDate: 'Check-In-Datum',
      departureDate: 'Check-Out-Datum',
      lengthOfStay: 'Aufenthaltsdauer (in Nächten)',
      totalNights: 'Gesamte Nächte',
      reservationNumber: 'Reservierungsnummer',
      rooms: 'Anzahl der Zimmer',
      stay: 'Aufenthaltsdauer (in Nächten)',
      airline: 'Fluggesellschaft / Carrier (2-stelliger Code)',
      originAirport: 'Abflughafen (3-stelliger Flughafencode)',
      destination: 'Ziel/Insel (3-stelliger Flughafencode)',
      cost: 'Gesamtkosten der Buchung (nur Dezimalzahlen verwenden)',
      totalCost: 'Gesamtkosten',
      file: 'RezSnap™ Nachweis-Upload',
      disclaimer: '* Pflichtfelder',
      button: 'Ihre Buchung einreichen',
      sub: 'Ihre Informationen',
      sub2: 'Buchungsinformationen',
      guests: 'Anzahl der Passagiere',
      numberOfPassengers: 'Anzahl der Passagiere',
      accommodationBooked: 'Gebuchtes Resort/Hotel/Unterkunft',
      accommodationCharterCompany: 'Hotel, Villa, Charterunternehmen',
      propertyCharterCompany: 'Immobilien / Charterunternehmen',
      typeofBooking: 'Art der Buchung',
      dragAndDrop: 'Ziehen Sie Dateien hierher oder klicken Sie, um Dateien auszuwählen',
      acceptedFiles: 'Es werden nur .jpeg-, .png- und .pdf-Dateien akzeptiert. Maximale Dateigröße ist 100 MB.',
      missingRequiredFields: 'Bitte füllen Sie alle erforderlichen Felder aus',
      invalidNumber: 'Muss eine Zahl größer als 0 sein.',
    },
    bookingFormCustom: {
      app1781: {
        fields: {
          previousVisits: 'Anzahl der vorherigen Besuche in der Mexikanischen Karibik',
          ambassadorReferralHeader: 'Botschafter-Empfehlung',
          referralFirstName: 'Vorname',
          referralFirstNamePlaceholder: 'Vorname (optional)',
          referralLastName: 'Nachname',
          referralLastNamePlaceholder: 'Nachname (optional)',
          referralEmail: 'E-Mail',
          referralEmailPlaceholder: 'E-Mail (optional)',
        },
      },
      app1439: {
        fields: {
          preOrPostCruise: 'Ist diese Buchung für einen Aufenthalt vor oder nach einer Kreuzfahrt?',
          tripPurpose: 'Reisezweck',
          departureAirport: 'Abflughafen (3-stelliger Flughafencode)',
        },
      },
    },
    TermsAndConditions: {
      title: 'Allgemeine Geschäftsbedingungen',
      button: 'Zurück',
    },
    thankYouPage: {
      thanks: 'Vielen Dank',
      congrats: 'Herzlichen Glückwunsch, ',
      body: 'Ihre Buchung wurde empfangen und zur Überprüfung an den Kampagnenleiter gesendet.',
    },
    menu: {
      home: 'Belohnungs-\nzentrum',
      homeAmbassador: 'Überblick',
      achievements: 'Trainings-\nerfolge',
      bookings: 'Buchungs-\nDashboard',
      form: 'Buchungen\neinreichen',
    },
  },
  badgeView: {
    title: 'Trainingsleistungen',
    subtitle:
      'Verfolgen Sie Ihren Trainingsfortschritt, Zertifizierungen und den Status Ihrer Metallauszeichnungen auf dieser Seite. Sie können auch Ihr {program_name_short}-Diplom sowie alle erworbenen Abzeichen herunterladen und teilen.',
    subtitleNoMetallic:
      'Verfolgen Sie Ihren Trainingsfortschritt und den Status Ihrer Zertifizierungen auf dieser Seite. Sie können auch Ihr {program_name_short}-Diplom sowie alle erworbenen Abzeichen herunterladen und teilen.',
    badgeDisplayTitle: 'Status der Metallauszeichnung',
    badgeAchievement:
      'Sie haben den {rank}-Status erreicht! Klicken Sie auf das Symbol rechts, um Ihren Status anzuzeigen und zu teilen.',
    bronze: 'Bronze',
    silver: 'Silber',
    gold: 'Gold',
    platinum: 'Platin',
    complete: 'ABGESCHLOSSEN',
    diploma: 'Diplom',
    chapterBadges: 'Spezialisierungsabzeichen',
    partnerBadges: 'Partner-Abzeichen',
    tierRewards: 'Stufenbelohnungen',
    click: 'Klicken ',
    here: 'hier',
    bronzeReward: ' um auf Ihre exklusive BRONZE-Belohnung zuzugreifen.',
    silverReward: ' um auf Ihre exklusive SILBER-Belohnung zuzugreifen.',
    goldReward: ' um auf Ihre exklusive GOLD-Belohnung zuzugreifen.',
    bronzeRewardTitle: 'Bronze Status Belohnung',
    silverRewardTitle: 'Silber Status Belohnung',
    goldRewardTitle: 'Gold Status Belohnung',
  },
  badgeDisplay: {
    status: 'Status der Trainingsleistung',
  },
  tierCard: {
    achieved: 'Erreicht',
    modules: 'Module',
    sales: 'Umsatz',
    bookings: 'Buchungen',
    or: 'oder',
    workingToward: 'Arbeite auf',
    currentTier: 'Aktuelle Stufe',
    workingTowardBronze: 'Schließen Sie die Zertifizierung ab, um den Bronze-Status zu erreichen!',
    expiresIn: 'Läuft ab in',
    days: 'Tagen',
    expiringToday: 'Läuft heute ab!',
    expiryDate: 'Ablaufdatum',
    nextTier: 'Nächste Stufe',
    nextGoal: 'Nächstes Ziel',
    allTiers: 'Alle Stufen',
    bronzeDescription: 'Belohnung für Berater, die die Grundlagen abschließen und erste Engagement zeigen.',
    silverDescription: 'Anerkennung für Berater, die konsequent verkaufen und engagiert bleiben.',
    goldDescription: 'Belohnung für Top-Performer, die intensiv in den Verkauf investiert sind.',
    title: {
      bronze: 'Bronze',
      silver: 'Silber',
      gold: 'Gold',
    },
    requirement: {
      bronze: 'Bahamas-Spezialisten-Zertifizierung abschließen',
      silver: '$5.000+ Bahamas-Reiseverkäufe oder 5+ Buchungen erzielen',
      gold: '$15.000+ Bahamas-Reiseverkäufe oder 15+ Buchungen erzielen',
    },
    tierCopy: 'Herzlichen Glückwunsch! Sie haben den {tier}-Status erreicht!',
  },
  search: {
    pages: 'Seiten',
    resources: 'Ressourcen',
  },
  categories: {
    all: 'Alle',
    accommodations: {
      accommodations: 'Unterkünfte',
      bedbreakfast: 'Bed & Breakfast',
      campgroundsrvparks: 'Campingplätze & Wohnmobilstellplätze',
      condo: 'Eigentumswohnung',
      hotel: 'Hotel',
      vacationrentals: 'Ferienvermietungen',
    },
    attractions: 'Attraktionen',
    dining: 'Gastronomie',
  },
  preregisterView: {
    comingSoon: 'Demnächst verfügbar:',
    title: 'Das neue {appName}',
    success:
      'Sie wurden erfolgreich für das Programm vorregistriert. Sie erhalten eine E-Mail, sobald das Programm startet.',
    fillRequired: 'Bitte füllen Sie alle erforderlichen Felder aus: {fields}',
    email: 'E-Mail',
    firstName: 'Vorname',
    lastName: 'Nachname',
    agencyName: 'Name der Agentur',
    country: 'Land',
    selectDefault: 'Bitte wählen Sie unten eine Option aus',
    requiredFields: '* Pflichtfelder',
    submit: 'Absenden',
    isRegistered:
      'Sie wurden erfolgreich für das Programm vorregistriert. Sie erhalten eine E-Mail, sobald das Programm startet.',
    somethingWentWrong: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
  },
  profileImageView: {
    currentImage: 'Dein aktuelles Profilbild:',
    uploadImage: 'Lade dein Profilbild hoch:',
    chooseAFile: 'Datei auswählen…',
    cancel: 'Abbrechen',
    backButton: 'Zurück',
    uploadButton: 'Profilbild hochladen',
    saveButton: 'Dieses Profilbild speichern',
    fileTooLargeTitle: 'Die Upload-Größe wurde überschritten',
    fileTooLargeText: 'Die maximale Bildgröße für den Upload beträgt 10 MB',
  },
  FastTrackView: {
    incorrectAnswer: 'Das ist nicht korrekt.',
    question: 'Q{current}/{total}',
    questionCounter: '{current} von {total} Fragen',
    score: 'Punktzahl: {correct}/{total}',
    nextIn: 'Weiter in {count}s',
    goToNextQuestion: 'Zur nächsten Frage',
    gradeEarned: 'Erhaltene Note',
    correct: 'Richtig',
    completeFastTrack: 'Fast Track abschließen',
    beginFullTraining: 'Vollständiges Training beginnen',
    fastTrackComplete: 'Fast Track abgeschlossen!',
    fastTrackNotPassed: 'Fast Track nicht bestanden',
    downloadDiploma: 'Diplom herunterladen',
    resultSuccessMessage: 'Herzlichen Glückwunsch — Sie haben den Fast Track bestanden und Ihr Diplom verdient!',
    resultAchievementsPrefix: ' Sie können Ihr Diplom im Bereich ',
    resultAchievementsLinkText: 'Trainingsleistungen',
    resultAchievementsSuffix: ' einsehen.',
    resultFailureMessage:
      'Leider haben Sie den Fast Track nicht bestanden. Er ist auf einen Versuch pro Nutzer beschränkt — aber Sie können Ihr Diplom dennoch verdienen! Arbeiten Sie das vollständige Training durch, um Ihr Wissen zu vertiefen, und schließen Sie es in Ihrem eigenen Tempo ab.',
  },
  smartAssist: {
    title: 'TA SmartAssist',
    pastConversations: 'Frühere Gespräche',
    showNextSuggestionsAria: 'Nächste Vorschläge anzeigen',
    headingAria: 'TA SmartAssist öffnen',
    headingResumeAria: 'Gespräch fortsetzen',
    homePlaceholder: 'Ask anything about travel in {destinationLabel}…',
    recentConversations: 'Letzte Gespräche',
    previousConversations: 'Frühere Gespräche',
    noRecentConversations: 'Keine kürzlichen Gespräche',
    deleteConversationAria: 'Gespräch löschen',
    chatSubtitle: 'Ask TA Smart Assist Anything About Travel in {destinationLabel}',
    startNewConversationAria: 'Neues Gespräch starten',
    sourcesFromApp: 'Quellen',
    loadingConversation: 'Gespräch wird geladen…',
    welcomePrompt: 'Ask any travel related questions about {destinationLabel}',
    loadingResponse: 'Wird verarbeitet…',
    messageLimitReached: 'Nachrichtenlimit erreicht',
    messageRemaining: 'Noch {remaining} Nachricht',
    messagesRemaining: 'Noch {remaining} Nachrichten',
    quotaBarAria: '{remaining} von {total} Nachrichten verbleibend',
    resetsAt: 'Zurückgesetzt am {resetLabel}',
    quotaChaptersPrompt: 'Earn certification for unlimited usage.',
    chatPlaceholder: 'Ask any travel related questions…',
    greetingFallback: 'Hi there',
    greetingName: 'Hi {firstName}',
    defaultDestination: 'diesem Reiseziel',
    appNotReady: 'App noch nicht konfiguriert.',
    signInRequired: 'Bitte melden Sie sich an, um fortzufahren.',
    genericError: 'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
    requestFailed: 'Anfrage fehlgeschlagen. Bitte erneut versuchen.',
    sourceFallback: 'Quelle',
    fallbackSuggestions: {
      bestBeaches: 'Beste Strände',
      familyActivities: 'Familienaktivitäten',
      hiddenGems: 'Geheimtipps',
      roadTrips: 'Roadtrips',
      dining: 'Beste Restaurants',
      events: 'Kommende Veranstaltungen',
    },
    structured: {
      confidenceThreshold: 'Konfidenz',
      confidenceThresholdPercentAria: 'Konfidenz: {percent}%',
      recommendation: 'Empfehlung',
      alignment: 'Abstimmungsprüfung',
      tailor: 'Zur weiteren Anpassung',
      tips: 'Effizienz-Tipps',
    },
  },
  imageGallery: {
    noticeTitle: 'Hinweis zur Bildnutzung',
    noticeText:
      'Alle Bilder sind ausschließlich an {clientName} lizenziert und dürfen nicht ohne Genehmigung verwendet werden',
  },
  toolbox: {
    completion: 'Schließe Die Grundlage ab, um dieses Element freizuschalten',
  },
};
